import { BASE_PRICE, CODE, DPSUBSIDYPROMOTION, INSTALLMENTS } from '../utils/constants';
import { alterHardwarePriceFormat } from '../utils/DeviceUtils';
import { ApiServiceV2 } from '@sunrise-upc/ajax-lib';
import { API_BASE_BASEPOINT } from './api-constants';
import { v4 as generateUID } from 'uuid';
import { DevicePropConfig } from './DevicePropConfig';

//setup device data for custom page
export const fetchCustomPageDeviceGroup = async (content: any, deviceCategory?: string) => {
  try {
    return new Promise<any>((res, rej) => {
      getDeviceDetailData(encodeURIComponent(`${CODE}${content?.m_p_id}`?.trim()), deviceCategory)
        ?.then((data: any) => {
          const hardObj = alterHardwarePriceFormat(data?.hardwares?.[0]?.hardwarePrices);
          return fetchPreviewCardDpSubsidyPromos(hardObj, data?.hardwares?.[0]?.id);
        })
        ?.then((resp: any) => {
          return res(resp);
        })
        ?.catch(() => rej());
    });
  } catch (error: any) {
    throw error;
  }
};

export const fetchPreviewCardDpSubsidyPromos = async (
  hardwarePrices: any,
  deviceId: any
): Promise<any> => {
  try {
    const dpSubsidyPromoRequestList: any = [];

    // created dpSubsidy rate plan request data list
    if (
      hardwarePrices?.[DPSUBSIDYPROMOTION] &&
      !hardwarePrices?.[DPSUBSIDYPROMOTION]?.discountedRatePlan
    ) {
      const discount = Number(hardwarePrices?.[DPSUBSIDYPROMOTION]?.discount?.value);
      const discountWithSmartUpgrade =
        Number(hardwarePrices?.smartUpgradeInstallments?.discount?.value) +
        Number(hardwarePrices?.[DPSUBSIDYPROMOTION]?.discount?.value);

      const discountPrice = hardwarePrices?.smartUpgradeInstallments
        ? discountWithSmartUpgrade
        : discount;
      dpSubsidyPromoRequestList.push(
        createDevicePlanRequest(discountPrice, hardwarePrices, deviceId)
      );

      if (dpSubsidyPromoRequestList?.length > 0) {
        return await fetchDpSubsidyDevicePlan(dpSubsidyPromoRequestList)?.then((res: any) => {
          let tempDevicesGroupList: any = {};
          tempDevicesGroupList = { ...hardwarePrices };
          const deviceIdKey = Object?.keys(res)?.[0];
          if (res?.[deviceIdKey]) {
            if (tempDevicesGroupList) {
              const ratePlan = {
                ...tempDevicesGroupList?.[DPSUBSIDYPROMOTION],
                discountedRatePlan: res?.[deviceIdKey]
              };
              tempDevicesGroupList = {
                ...tempDevicesGroupList,
                dPSubsidyPromotion: ratePlan
              };
            }
          }
          return tempDevicesGroupList;
        });
      }
    } else {
      return hardwarePrices;
    }
  } catch (error: any) {}
};

//DeviceDetail API Call
export const getDeviceDetailData = async (
  deviceDetailsProductId: string,
  deviceCategory?: string
) => {
  const endPoint = DevicePropConfig?.getInstance()?.getBaseUrl();
  const options = {
    params: {},
    headers: {
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': API_BASE_BASEPOINT.X_SUN_CHAL
    }
  };

  let URL =
    endPoint +
    API_BASE_BASEPOINT?.DEVICE_AL_GROUP +
    '?filterSearchOption.id=' +
    deviceDetailsProductId;

  const resp = await ApiServiceV2.getApiServiceInstance()
    .get(URL, options)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {
      throw Error('Promise failed to fetch Device Detail Group Data!');
    });
  return resp;
};

export const createDevicePlanRequest = (
  discountPrice: any,
  hardwarePrices: any,
  deviceKey: string
) => {
  return {
    discount: discountPrice,
    oneTimePrice: Number(hardwarePrices?.[BASE_PRICE]?.upFrontPayment?.value),
    duration: Number(hardwarePrices?.[INSTALLMENTS]?.duration),
    upfront: Number(hardwarePrices?.[INSTALLMENTS]?.upFrontPayment?.value),
    deviceId: deviceKey
  };
};

export const fetchDpSubsidyDevicePlan = async (devicePlanRequestList: any) => {
  const data = devicePlanRequestList?.[0];
  const endPoint = DevicePropConfig?.getInstance()?.getBaseUrl();
  const options = {
    params: {},
    headers: {
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': API_BASE_BASEPOINT?.X_SUN_CHAL
    }
  };

  const URL = endPoint + API_BASE_BASEPOINT?.DEVICE_AL_DP_SUBSIDY_RATE_PLAN;

  const createReqBody = {
    detail: [
      {
        discount: data?.discount,
        duration: data?.duration,
        streetPrice: data?.oneTimePrice,
        upfront: data?.upfront
      }
    ]
  };
  return new Promise((resolve, reject) => {
    return ApiServiceV2.getApiServiceInstance()
      ?.post(URL, createReqBody, options)
      .then((res) => {
        const responseData: { [key: string]: any } = {};
        responseData[data?.deviceId] = res?.data;
        return resolve(responseData);
      })
      .catch(() => {
        reject();
        return Error('Promise failed to fetch Rate Plan Data!');
      });
  });
};
